import {NSearchPickerComponent} from "./n-search-picker.component";
import {SearchPickerNoResultsRenderer} from "./SearchPickerNoResultsRenderer";
import {ModuleWithProviders, NgModule} from "@angular/core";

@NgModule({
  declarations: [
    NSearchPickerComponent
  ], // directives, components, and pipes owned by this NgModule
  imports: [
    // dependencies
  ],
  exports: [
    NSearchPickerComponent
  ],
  providers: [
    SearchPickerNoResultsRenderer
  ],
  entryComponents: []
})
export class NSearchPickerModule {
  static forRoot(): ModuleWithProviders<NSearchPickerModule> {
    return {
      ngModule: NSearchPickerModule,
      providers: [
        SearchPickerNoResultsRenderer
      ]
    };
  }
}
